var map = {
	"./anteraja.png": 1513,
	"./bg-topo-dark-blue.png": 1514,
	"./biteship-blibli.png": 1515,
	"./biteship-bukalapak.png": 1516,
	"./biteship-dashboard-api.png": 1517,
	"./biteship-dhl.png": 1518,
	"./biteship-gosend.png": 1519,
	"./biteship-grab.png": 1520,
	"./biteship-idx.png": 1521,
	"./biteship-indah.png": 1522,
	"./biteship-janio.png": 1523,
	"./biteship-jd.png": 1524,
	"./biteship-jdl.png": 1525,
	"./biteship-label.png": 1526,
	"./biteship-lalamove.png": 1527,
	"./biteship-lazada.png": 1528,
	"./biteship-logo-icon.png": 1529,
	"./biteship-magento.png": 1530,
	"./biteship-monitor-icon.png": 1531,
	"./biteship-popexpress.png": 1532,
	"./biteship-prestashop.png": 1533,
	"./biteship-puzzle-icon.png": 1534,
	"./biteship-rara.png": 1535,
	"./biteship-shopee.png": 1536,
	"./biteship-shopify.png": 1537,
	"./biteship-tiktok.png": 1538,
	"./biteship-tlx.png": 1539,
	"./biteship-tokopedia.png": 1540,
	"./biteship-via-api.png": 1541,
	"./biteship-via-mobile-app.png": 1542,
	"./biteship-via-plugin.png": 1543,
	"./biteship-via-web-app.png": 1544,
	"./biteship-woo-checkout.png": 1545,
	"./biteship-woo.png": 1546,
	"./biteship-zalora.png": 1547,
	"./borzo.png": 1548,
	"./dashboard-home.png": 1549,
	"./deliveree.png": 1550,
	"./eslexpress.png": 1551,
	"./fedex.png": 1552,
	"./fulfillment_swift.png": 1553,
	"./gosend.png": 1554,
	"./grab.png": 1555,
	"./home_app.png": 1556,
	"./idexpress.png": 1557,
	"./jdl.png": 1558,
	"./jet.png": 1559,
	"./jne.png": 1560,
	"./jnt.png": 1561,
	"./lalamove.png": 1562,
	"./lion.png": 1563,
	"./make_order.png": 1564,
	"./make_order_old.png": 1565,
	"./ninja.png": 1566,
	"./paxel.png": 1567,
	"./pos.png": 1568,
	"./qrim.png": 1569,
	"./rpx.png": 1570,
	"./sap.png": 1571,
	"./shopify-logo.png": 1572,
	"./sicepat.png": 1573,
	"./sq_anteraja.png": 1574,
	"./sq_biteship.png": 1575,
	"./sq_deliveree.png": 1576,
	"./sq_fedex.png": 1577,
	"./sq_gojek.png": 1578,
	"./sq_grab.png": 1579,
	"./sq_idexpress.png": 1580,
	"./sq_jet.png": 1581,
	"./sq_jne.png": 1582,
	"./sq_jnt.png": 1583,
	"./sq_lalamove.png": 1584,
	"./sq_lion.png": 1585,
	"./sq_paxel.png": 1586,
	"./sq_rpx.png": 1587,
	"./sq_sicepat.png": 1588,
	"./sq_swift.png": 1589,
	"./sq_tiki.png": 1590,
	"./sq_wahana.png": 1591,
	"./tiki.png": 1592,
	"./wahana.png": 1593,
	"./why_bg.png": 1594,
	"./woo-logo.png": 1595,
	"./woocommerce-logo.png": 1596,
	"./wp-header.png": 1597
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1512;